// extracted by mini-css-extract-plugin
module.exports = {"PrimaryInput":"PrimaryInput_PrimaryInput__1JrAj","FullWidth":"PrimaryInput_FullWidth__1-zTx","Narrow":"PrimaryInput_Narrow__2bTqO","VeryNarrow":"PrimaryInput_VeryNarrow__d0twU"};